import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { OLD_PRICE, PRICE } from '../data/mat';
const recap = ['10 tomów', '5 bonusów', '600+ stron', 'Od klasy 4 do matury'];
const reassurances = ['Natychmiastowy dostęp do pobrania', 'PDF-y do wydruku', '7 dni gwarancji satysfakcji'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-seyes px-8 py-24 sm:px-14 sm:py-32" data-id="element-114" data-mp="15fgialsjv51g">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-red-300 sm:left-8 lg:left-12" data-id="element-115" data-mp="1jb212b86wslf" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-116" data-mp="1t2on72m2gc2y">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-117" data-mp="1t251datap3jn">
          Twoje lekcje matematyki mogą być <em className="text-red-700" data-id="element-118" data-mp="223cyhpk2ryc5">gotowe już dziś.</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-900/75" data-id="element-119" data-mp="221a0ai8rqywc">
          Zamiast szukać zadań po dziesiątkach stron, rysować każdy wykres od zera i spędzać niedzielne
          wieczory na przygotowaniach, masz uporządkowany pakiet z matematyki na cały rok szkolny. Więcej
          czasu na to, co naprawdę ważne:
        </p>
        <p className="mt-6 font-serif text-2xl italic leading-snug text-slate-900 sm:text-3xl" data-id="element-120" data-mp="x2qsg212pzio">
          Twoi uczniowie. Twoje lekcje. Twoje życie poza szkołą.
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-900/70" data-id="element-121" data-mp="16504wxfwk2yp">
          {recap.map(item => <li key={item} data-id="element-122" data-mp="1b28mowx524zf">{item}</li>)}
        </ul>

        <p className="mt-8 font-serif text-2xl leading-none text-slate-900/50" data-id="element-123" data-mp="1fua04m61m1r1">
          <span className="sr-only" data-id="element-124" data-mp="1fwmbgghapdv4">Cena regularna: </span>
          <s data-id="element-125" data-mp="1ks1nr3znn1pf">{OLD_PRICE}</s>
        </p>
        <p className="mt-3 font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-7xl" data-id="element-126" data-mp="1kv7dmlg3y7m7">
          <span className="sr-only" data-id="element-127" data-mp="1pqmp56qn7rfg">Cena teraz: </span>
          {PRICE}
        </p>
        <p className="mt-3 text-sm text-slate-900/70" data-id="element-128" data-mp="1tryinncn0wsx">Jednorazowa płatność – bez subskrypcji.</p>

        <div className="mt-8 flex justify-center" data-id="element-129" data-mp="3qsktodp4nwp4">
          <CtaButton className="w-full sm:w-auto" data-id="element-130" data-mp="3lwdncjstkj6n" />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-1.5 text-sm text-slate-900/70" data-id="element-131" data-mp="3hl5l7g1yecm">
          {reassurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-132" data-mp="3uw0nl29tbiy4">
              <CheckIcon className="h-4 w-4 text-red-700" aria-hidden="true" data-id="element-133" data-mp="3uufwjmmpii50" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}